import { BrandKey, brandKeysByUnit } from '@prismamedia/one-brandkey';
import { BrandKey as QueryBrandKey } from '__generated__/queries-web';

export const getFilteredBrandKey = (brandKey: BrandKey | string | null) => ({
  brandKey_in: (brandKey === BrandKey.TRV
    ? undefined
    : brandKey === BrandKey.FRGTS
    ? brandKeysByUnit[brandKey].filter((bk) => bk !== BrandKey.FRGTS)
    : [brandKey]) as QueryBrandKey[],
});
